<!-- 登录页面（与注册页统一深色科技风） -->
<template>
  <div class="login-page">
    <!-- 顶部语言切换 -->
    <div class="login-top">
      <language class="top-lang" />
    </div>

    <!-- 主体 -->
    <div class="login-main">
      <div class="login-card">
        <!-- 左侧：品牌 -->
        <div class="login-aside">
          <div class="brand">
            <img class="brand-logo" src="../../assets/logo.png" alt="logo">
            <p class="brand-title">{{ $t('text.loginWelcome') }}</p>
          </div>
        </div>

        <!-- 右侧：登录表单 -->
        <div class="login-body">
          <div class="login-title">
            <h3>{{ $t('button.login') }}</h3>
            <p>{{ $t('text.loginTip') }}</p>
          </div>

          <el-form ref="loginForm" :model="loginForm" :rules="loginFormRules" autocomplete="off" label-position="left" label-width="90px" class="login-form-wrap">
            <el-form-item :label="$t('text.yhm')" prop="username">
              <el-input v-model="loginForm.username" clearable autocomplete="off" />
            </el-form-item>
            <el-form-item :label="$t('text.mm')" prop="password">
              <el-input
                v-model="loginForm.password"
                show-password
                autocomplete="off"
                @keyup.enter.native="handleLogin"
              />
            </el-form-item>
            <div class="remember-row">
              <el-checkbox v-model="loginForm.rememberMe" :label="$t('text.jzmm')" />
            </div>
            <el-button
              :loading="loading"
              type="primary"
              class="btn-login"
              @click.native.prevent="handleLogin"
            >
              <span v-show="!loading">{{ $t('button.login') }}</span>
              <span v-show="loading">{{ $t('button.dlz') }}</span>
            </el-button>
            <div class="register-link">
              <span>{{ $t('text.noaccount') }}</span>
              <a @click="handleRegister">{{ $t('text.register') }}</a>
            </div>
          </el-form>

          <div class="login-footer">
            <img class="app-img" src="../../assets/general.png" alt="">
            <p>{{ $t('text.smxz') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { encrypt, decrypt } from '@/utils/jsencrypt'
import language from '../../layout/header/Language.vue'

import Cookies from 'js-cookie'
export default {
  name: 'Login',
  components: {
    language
  },
  data () {
    return {
      loginForm: {
        username: '',
        password: '',
        rememberMe: false
      },
      loginFormRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      loading: false
    }
  },
  created () {
    this.getCookie()
  },
  methods: {
    /** 获取保存的用户名和密码 */
    getCookie () {
      const username = Cookies.get('username')
      const password = Cookies.get('password')
      const rememberMe = Cookies.get('rememberMe')
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password === undefined ? this.loginForm.password : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      }
    },
    /** 登录事件 */
    handleLogin () {
      this.$refs.loginForm.validate().then(() => {
        this.loading = true
        this.$store.dispatch('user/login', this.loginForm)
          .then(() => {
            if (this.loginForm.rememberMe) {
              Cookies.set('username', this.loginForm.username, { expires: 7 })
              Cookies.set('password', encrypt(this.loginForm.password), { expires: 7 })
              Cookies.set('rememberMe', this.loginForm.rememberMe, { expires: 7 })
            } else {
              Cookies.remove('username')
              Cookies.remove('password')
              Cookies.remove('rememberMe')
            }
            this.$router.push({ path: '/home' })
          })
          .catch(() => {
            this.loading = false
          })
      })
    },
    // 注册页面
    handleRegister () {
      this.$router.push('/register')
    }
  }
}
</script>
<style scoped>
@import './style.css';
</style>
